import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import { connect } from "react-redux";
import {
  changeWebsiteItemGlobalData,
  editCustomStyles,
} from "../../../store/websites/actions";
import { getCurrentStoreData } from "../../../store/websites/thunks";
import { GetCurrentStoreData } from "../../../store/websites/types";
import _ from "lodash";

interface Props {
  editCustomStyles: any;
  changeWebsiteItemGlobalData: any;
  getCurrentStoreData: GetCurrentStoreData;
}
const CustomCssStyleMenu = (props: Props) => {
  const { currentWebsite } = props.getCurrentStoreData();
  const inputValue = _.get(currentWebsite, "custom_styles.customCss", "");
  const handleOnChange = (e) => {
    const { value } = e.target;
    props.editCustomStyles({
      websiteId: currentWebsite.id,
      newData: {
        customCss: value,
      },
    });
    props.changeWebsiteItemGlobalData({
      websiteId: currentWebsite.id,
      data: {
        hasUnsavedChanges: true,
      },
    });
  };
  return (
    <div style={{ padding: "0 8px" }}>
      <TextArea
        placeholder={`.title {
font-size: 24px;
color: #000;
}`}
        rows={4}
        style={{ borderRadius: "6px" }}
        value={inputValue}
        onChange={handleOnChange}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    websites: state.websites,
  };
};
export default connect(mapStateToProps, {
  editCustomStyles,
  changeWebsiteItemGlobalData,
  getCurrentStoreData,
})(CustomCssStyleMenu);
